import { Injectable } from '@angular/core';
import { ApiEnvironment } from '@lx/shared/types';
import { environment } from '../environments/environment';
import { BaseConfigService } from '@lx/shared/app-config';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigurationService extends BaseConfigService {
  protected fetchApiEnvironment(): ApiEnvironment {
    return {
      API_BASE_PATH: environment.API_BASE_PATH,
    };
  }
}
